

<fury-page-layout mode="card">
  <fury-page-layout-header>
    <h2>Change Third Party Api Status</h2>
  </fury-page-layout-header>
  <fury-page-layout-content [@fadeInUp]>
    <div class="service_aggreementBox">
        <div class="apibody flex">
          <div class="flex">
            <p> Liberty Api Status: </p> 
            <mat-slide-toggle [(ngModel)]="thirdPartyStatus.libertyStatus" (change)="changeStatus($event, 'Liberty')"></mat-slide-toggle>
          </div>
        
            <button mat-raised-button color="primary" (click)="openExcludeLeadSourceModal('liberty')">Exclude Lead Source</button>
        </div>
        <div class="apibody flex">
          <div class="flex">
            <p> Home Warranty Review Api Status: </p> 
          <mat-slide-toggle [(ngModel)]="thirdPartyStatus.homeWarrantyReviewStatus" (change)="changeStatus($event, 'Home Warranty Review')"></mat-slide-toggle>
          </div>
          
          <button mat-raised-button color="primary" (click)="openExcludeLeadSourceModal('home warranty review')">Exclude Lead Source</button>
        </div>
    </div>
  </fury-page-layout-content>
</fury-page-layout>